export default __webpack_public_path__ + "static/media/basket-big.44e379c3.svg";